<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">单位名称</div>
          <div class="field">
            <el-input v-model.trim="query.comfullname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">支付方式</div>
          <div class="field">
            <el-select
              v-model="query.paytype"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in paytypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">开票状态</div>
          <div class="field">
            <el-select
              v-model="query.fpflg"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in fpList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">支付时间</div>
          <div class="field" style="width: 400px">
            <el-date-picker
              v-model="query.begTime"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
            <div style="margin: 0 10px">至</div>
            <el-date-picker
              v-model="query.endTime"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type="primary" @click="search">查询</el-button>
            <el-button
              v-if="+query.comtype === 1"
              type="primary"
              @click="showButton = !showButton"
              >{{ showButton ? "收起" : "展开" }}</el-button
            >
          </div>
        </div>
      </div>
      <div>
        <el-collapse-transition v-if="+query.comtype === 1">
          <div v-show="showButton" style="padding: 10px">
            <el-radio-group v-model="areaid" @change="getPageList">
              <el-radio-button
                v-for="item in this.areaList"
                :key="item.dptareacode"
                :label="item.dptareacode"
                >{{ item.label }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </el-collapse-transition>
      </div>
    </div>

    <vggrid
      :list="list"
      tableheight="600"
      flexname=""
      :cols="cols"
      :showfooter="false"
      :showPage="true"
      :resizable="true"
      :defaultPage="10"
      :total="query.total"
      @cellClick="cellClick"
      @cellDblClick="viewProject"
      @pagechange="pagechange"
      :isOperate="btn.isOperate"
      :operateBtn="btn.right"
      @vggridClick="vggridClick"
    >
      <template slot="btn">
        <div style="height: 41px; line-height: 41px; display: flex">
          <div style="margin-right: 10px" v-if="amt">
            【报名费】：{{ amt.bm_amt | Thousands }}元
          </div>
          <el-checkbox v-model="query.hasreturn" @change="getAmtSum"
            >包含退还</el-checkbox
          >
        </div>
      </template>
    </vggrid>
  </Container>
</template>
<script>
import request from "@/utils/request";
import MenuBtn from "../common/menuBtn";
import vggrid from "../common/vggrid";
import dayjs from "dayjs";
import utils from "../../assets/js/utils";
export default {
  name: "psuBmfAffirmIndex",
  data() {
    return {
      menuid: this.$route.query.menuid,
      list: [],
      btn: {},
      paytypeList: [
        { label: "支付宝支付", value: "1" },
        { label: "微信支付", value: "2" },
        { label: "线下支付", value: "3" },
      ],
      fpList: [
        { label: "未开", value: "1" },
        { label: "已开", value: "2" },
      ],
      btnLoading: false,
      amt: {},
      cols: [
        {
          type: "index",
          fieldtype: "I",
          title: "行号",
          calculExpr: "",
          width: 50,
        },
        {
          field: "projectcode",
          fieldtype: "C",
          title: "项目编号",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "projectname",
          fieldtype: "C",
          title: "项目名称",
          calculExpr: "",
          addNewRowFlg: false,
          width: 200,
        },
        {
          field: "comfullname",
          fieldtype: "C",
          title: "报名单位",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psubmamtdesc",
          fieldtype: "C",
          title: "报名费",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psubmusername",
          fieldtype: "C",
          title: "支付人",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psubmpaytypedesc",
          fieldtype: "C",
          title: "支付方式",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psubmpaytime",
          fieldtype: "C",
          title: "支付时间",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psubmpaycheckusername",
          fieldtype: "C",
          title: "确认人",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psubminvoiceflgname",
          fieldtype: "C",
          title: "发票",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          title: "操作 ",
          width: 130,
          showOverflow: true,
          slots: {
            default: "default",
            default: ({ row }) => {
              if (
                +row.psubmpayflg === 1 &&
                (+row.psubminvoiceflg === 2 || +row.psubmreturnflg === 1)
              )
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.QRBMF.bind(this, row)}
                  >
                    查看
                  </vxe-button>,
                ];
              else if (+row.psubmpayflg !== 1)
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.QRBMF.bind(this, row)}
                  >
                    收款
                  </vxe-button>,
                ];
              else if (
                (+row.projectstopflg === 1 || +row.projectcancelflg === 1) &&
                +row.psubminvoiceflg === 1 &&
                +row.psubmreturnflg !== 1
              )
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.QRBMF.bind(this, row)}
                  >
                    退回{" "}
                  </vxe-button>,
                ];
              else
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.QRBMF.bind(this, row)}
                  >
                    登记发票
                  </vxe-button>,
                ];
            },
          },
        },
      ],
      psu: {},
      areaid: 0, //查询地区id
      showButton: true,
      areaList: [],
      query: {
        comid: this.$store.getters.loginUser.comid,
        comtype: this.$store.getters.loginUser.comtype,
        userid: this.$store.getters.loginUser.userid,
        hasreturn: false,
        total: 0,
        limit: 10,
        offset: 0,
      },
    };
  },
  created() {
    this.$on("CONFIRM", () => this.QRBMF());
    this.$on("CLOSE", () => this.close());
  },
  activated() {
    this.init();
    this.getPageList();
    if (this.query.comtype === 1) {
      this.getareaList();
    }
  },
  mounted() {},
  watch: {},
  filters: {
    Thousands(val) {
      return val ? utils.comdify(val) : 0;
    },
  },
  components: { MenuBtn, vggrid },
  methods: {
    btnClick(code) {
      this.$emit(code);
    },
    vggridClick(code, row) {
      this.psu = row;
      this.$emit(code, row);
    },
    async init() {
      this.list = [];
      this.btnLoading = false;
      this.psu = {};
    },
    async viewProject(row) {
      this.psu = row.row;
      this.$router.push({
        name: "psuBmfAffirmForm",
        params: { form: this.psu, innerbtn: this.btn.inner, type: 3 },
      });
    },
    btnmenuclick(btn) {
      this.btn = btn;
    },
    async cellClick(row) {
      this.psu = row.row;
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1);
      this.query.limit = page.pageSize;
      this.getPageList();
    },
    async getAmtSum() {
      let res = await request({
        method: "get",
        url: "/cwgl/psuproject/getAmtSum",
        params: this.query,
      });

      this.amt = res[0];
    },
    async getPageList() {
      this.loading = true;
      this.query.cosid = this.$store.getters.loginUser.cosid;
      this.query.areaid = this.areaid;
      this.query.selectField = `projectcode,projectptccode,projectname,projecttime,psubminvoicenum,
        projectid,projectstatus,projectisinvite,projectisqcheck,comfullname,projectcancelflg,projectstopflg,psubzjreturnflg,psubmreturnflg,
        psubmpaytime,psubmpaychecktime,psubmpaytype,psubminvoiceflg,psubmamt,psuid,psubmpayflg`;
      let res = await request({
        method: "get",
        url: "/cwgl/psuproject/getBMFPageList",
        params: this.query,
      });
      res.list.forEach((e) => {
        e.psubmpaychecktime = utils.formatterDate(
          e.psubmpaychecktime,
          "yyyy-MM-dd HH:mm:ss"
        );
        e.psubmpaytime = utils.formatterDate(e.psubmpaytime, "yyyy-MM-dd");
        if (+e.psubmpaytype === 1 || +e.psubmpaytype === 2) {
          e.psubmpaycheckusername = "线上支付";
        }
        e.psubminvoiceflgname =
          +e.psubminvoiceflg === 1
            ? "未开"
            : +e.psubminvoiceflg === 2
            ? e.psubminvoicenum
            : "";
        e.psubmpaytypedesc =
          +e.psubmpaytype === 1
            ? "支付宝支付"
            : +e.psubmpaytype === 2
            ? "微信支付"
            : +e.psubmpaytype === 3
            ? "线下支付"
            : "";
        e.psubmreturnflgdesc = "";
        // if (+e.projectcancelflg === 1 || +e.projectstopflg === 1) {
          e.psubmreturnflgdesc =
            +e.psubmreturnflg === 1
              ? "(已退)"
              : ""
              // : +e.psubminvoiceflg === 2
              // ? ""
              // : "(未退)";
          // e.psubmreturnflgdesc = +e.psubminvoiceflg === 1? '':+e.psubmreturnflg === 1  ? '(已退)':'(未退)'
        e.psubmamtdesc = utils.comdify(e.psubmamt) + e.psubmreturnflgdesc;
        e.psubmusername = e.psubmusername
          ? e.psubmusername + " " + e.psubmuserphone
          : "";
      });
      this.list = res.list;
      this.query.total = res.count[0].count;
      this.getAmtSum();
      this.loading = false;
    },
    async QRBMF(row) {
      this.psu = row;
      this.$router.push({
        name: "psuBmfAffirmForm",
        params: { form: this.psu, type: 1 },
      });
    },
    async search() {
        this.query.offset = 0
      // this.query.paytype = 3
      if (this.query.endTime) {
        this.query.endtime = dayjs(this.query.endTime)
          .add(1, "day")
          .format("YYYY-MM-D");
      }
      this.getPageList();
    },
    //获取地区list
    async getareaList() {
      let res = await request({
        method: "get",
        url: "/xtgl/dpt/getDptareaList",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.areaList = res.filter((e) => {
        return +e.dptareause === 1;
      });
      this.areaList.unshift({
        dptareacode: 0,
        label: "全部",
      });
    },
  },
};
</script>
<style lang="scss">
.search-box {
  margin-left: 20px;
}
</style>
